module.exports = __webpack_public_path__ + "img/shouYiDuiXiang.fb56c88e.png";